import { Button, Col, Form, Row, Upload, message } from 'antd';
import React, { useEffect, useImperativeHandle, useState } from 'react';
import { LoadingOutlined, UploadOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import TitleSection from '../atoms/TitleSection';
import uploadRepo from '../../services/repository/upload';
import { FormInstance } from 'antd/lib/form';
import { AxiosError } from 'axios';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
`;

const ColGrid = styled(Col)`
  display: flex;
  flex-direction: column;
`;

const UploadButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const uploads = [
  {
    id: 0,
    title: 'Carteira de Trabalho e Previdência Social (CTPS)',
    type: 'carteira_profissional',
  },
  {
    id: 1,
    title: 'Comprovante de Endereço',
    type: 'comprovante_de_endereco',
  },
  {
    id: 2,
    title: 'Foto 3x4 (1 unidade)',
    type: '01_foto_3x4',

  },
  {
    id: 3,
    title: 'Comprovante de Escolaridade',
    type: 'comprovante_de_escolaridade',

  },
  {
    id: 4,
    title: 'Carteira de Identidade (RG)',
    type: 'copia_da_cedula_de_identidade',
  },
  {
    id: 5,
    title: 'Certidão de Nascimento',
    type: 'certidao_de_nascimento',
  },
  {
    id: 6,
    title: 'Cadastro de Pessoa Física (CPF)',
    type: 'copia_do_cpf',
  },
  {
    id: 7,
    title: 'Certidão de Casamento',
    type: 'certidao_de_casamento',
  },
  {
    id: 8,
    title: 'Titulo de Eleitor',
    type: 'titulo_de_eleitor',
  },
  {
    id: 9,
    title: 'Certidão dos filhos menores de 21 anos',
    type: 'certidao_dos_filhos_menores_de_21_anos',
  },
  {
    id: 10,
    title: 'Certificado de Reservista',
    type: 'certificado_de_reservista',
  },
  {
    id: 11,
    title: 'Carteira de vacinação dos filhos menores\n' +
      'de 07 anos',
    type: 'carteira_de_vacinacao_dos_filhos_menores_de_07_anos',
  },
  {
    id: 12,
    title: 'Carteira Nacional de Habilitação (CNH)',
    type: 'carteira_de_motorista',
  },
  {
    id: 13,
    title: 'Comprovante de frequência escolar dos filhos de 7 a 14 anos',
    type: 'comprovante_de_frequencia_escolar_dos_filhos_de_7_a_14_anos',
  },
  {
    id: 14,
    title: 'PIS/PASEP',
    type: 'pis_pasep',
  },
  {
    id: 14,
    title: 'Exame Admissional',
    type: 'exame_admissional',
  },
  {
    id: 14,
    title: 'Anexar Procuração',
    type: 'anexar_procuracao',
  },
];

interface FileItem {
  uid: string;
  name: string;
  status: 'done' | 'uploading' | 'error' | 'removed';
  url: string;
  type: string;
}


type Props = {
  handleNext: () => void,
  files: { uid: string; nomeArquivo: string, type: string, url: string  }[];
};


const UploadDocuments = React.forwardRef<FormInstance, Props>(({ handleNext, files }, ref) => {
  const [fileList, setFileList] = useState<FileItem[]>([]);
  const [form] = Form.useForm();

  // @ts-ignore
  useImperativeHandle(ref, () => ({
    validateFields: () => form.validateFields(),
    getFieldsValue: form.getFieldsValue,
  }));


  useEffect(() => {
    if (files.length > 0) {
      setFileList(
        files.map((file) => ({
          uid: file.uid,
          name: file.type,
          status: 'done',
          url: file.url,
          type: file.type,
        })),
      );
    }
  }, [files]);

  const [typeBeingUploaded, setTypeBeingUploaded] = useState<string | undefined>();

  return (
    <Wrapper>
      <Row gutter={16}>
        <p><b>* Extensões suportadas: PDF,PNG e JPEG. Tamanho máximo por arquivo: 10MB.</b></p>
      </Row>

      <Row gutter={[16, 16]}>
        {uploads.map((upload, index) => (
          <ColGrid xs={24} sm={24} md={12} lg={12} key={index}>
            <TitleSection>{upload.title}</TitleSection>

            <Upload
              name='file'
              accept='image/png,image/jpeg,application/pdf'
              beforeUpload={async (file) => {
                try {
                  setTypeBeingUploaded(upload.type);
                  const { data: responseFile } = await uploadRepo.upload(file, upload.type);
                  setFileList([
                    ...fileList,
                    {
                      uid: file.uid,
                      name: responseFile.type,
                      status: 'done',
                      url: responseFile.url,
                      type: responseFile.type,
                    },
                  ]);
                } catch (e) {
                  console.error('Ocorreu um erro ao fazer upload do arquivo', e);

                  if (e instanceof AxiosError) {
                    if (e.response?.status === 413) {
                      message.error('Não é possível inserir documento com tamanho maior 10 MB.', 10);
                    }
                    else if (e.response?.data.errors?.[0]?.code === 'VALIDATION_ERROR') {
                      message.error('Não é possível inserir documento de tipo diferentes de Jpeg, PNG e PDF.', 10);
                    }
                    else {
                      message.error('Ocorreu um erro ao fazer upload do arquivo', 10);
                    }
                  }
                  else {
                    message.error('Ocorreu um erro ao fazer upload do arquivo', 10);
                  }
                }
                finally {
                  setTypeBeingUploaded(undefined);
                }
              }}
              multiple
              maxCount={30}
              onRemove={(file) => {
                uploadRepo.removeUplodadedFile(upload.type);
                setFileList(fileList.filter((f) => f.uid !== file.uid));
              }}
              showUploadList={{ showDownloadIcon: true }}
              fileList={fileList.filter((f) => f.type === upload.type)}
            >
              <UploadButtonWrapper>
                <Button icon={<UploadOutlined />}>Upload</Button>

                {typeBeingUploaded === upload.type &&
                  <LoadingOutlined
                    style={{ fontSize: '1.5rem' }}
                  />
                }
              </UploadButtonWrapper>
            </Upload>
          </ColGrid>
        ))}
      </Row>

      <Row style={{ marginTop: '36px', justifyContent: 'flex-end' }}>
        <Form.Item>
          <Button type={'primary'} onClick={() => handleNext()}>Prosseguir</Button>
        </Form.Item>
      </Row>
    </Wrapper>
  );

});

UploadDocuments.displayName = 'UploadDocuments';


export default UploadDocuments;
